import { ChakraVisuallyHidden } from "@hightouch/htui";
import { ReactNode } from "react";

/**
 * Render a form label that is visually hidden but still accessible to screen readers.
 * Use when a form element cannot have a visible label due to UI constraints.
 *
 * @param label - The label to render.
 * @param children - The form element to render inside the label.
 */
export function HiddenFormLabel({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <label>
      <ChakraVisuallyHidden>{label}</ChakraVisuallyHidden>
      {children}
    </label>
  );
}
